<!--
 * @Author: your name
 * @Date: 2021-12-28 11:50:39
 * @LastEditTime: 2021-12-29 11:34:15
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \icps_pcweb\src\views\platform\ICPS\smart\materialcheckout\components\CementMortarDialog.vue
-->
<template>
    <el-dialog v-dialogDrag :title="config.type === 'add' ? '添加' : '修改'" :visible.sync="visible" width="400px" :close-on-click-modal="false" @close="onClose" @open="onOpen">
        <div class="dialog_box">
            <el-form ref="form" label-width="100px">
                <el-form-item label="供应商">
                    <span slot="label" class="require">供应商</span>
                    <el-select v-model="supplier" value-key="id" placeholder="请选择" @change="changeSupplier">
                        <el-option v-for="item in supplierIdList" :key="item.id" :value="item" :label="item.name" />
                    </el-select>
                </el-form-item>
                <el-form-item label="原物料">
                    <span slot="label" class="require">原物料</span>
                    <el-select v-model="raw" value-key="id" placeholder="请选择" @change="changeRaw">
                        <el-option v-for="item in rawIdList" :key="item.id" :value="item" :label="item.name" />
                    </el-select>
                </el-form-item>
                <el-form-item label="站点">
                    <span slot="label" class="require">站点</span>
                    <el-select v-model="station" value-key="id" placeholder="请选择" @change="changeStation">
                        <el-option v-for="item in siteIdList" :key="item.id" :value="item" :label="item.name" />
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button class="bottom_all_two" @click="onClose">取 消</el-button>
            <el-button class="bottom_all" @click="onConfirm">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { queryRawContractList, saveSubmitInspection } from '@/api/inspect'
import { getStationByCompanyId } from "@/api/common.js";
export default {
    props: {
        config: {
            type: Object,
            default: ()=>{}
        },
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            supplier: {}, // 供应商
            raw: {}, // 原物料
            station: {}, // 站点

            siteIdList: [],
            rawIdList: [],
            supplierIdList: [],
            params: {
                company: '', // 公司
                companyId: '',
                supplierName: '', // 供应商
                supplierId: '',
                contractNo: '', // 合同
                contractId: '',
                rawName: '', // 原物料
                rawId: '',
                station: '', // 站点
                stationId: ''
            }
        }
    },
    methods: {
        // 选择供应商
        changeSupplier(e) {
            if(!e) return;
            this.params.supplierName = e.name;
            this.params.supplierId = e.id;
            this.params.contractNo = e.contractNo;
            this.params.contractId = e.contractId;
            // 原物料下拉数据
            this.raw = {};
            this.rawIdList = e.products.map(item=>({
                id: item.productId,
                name: item.productName
            }))
        },
        // 选择原物料
        changeRaw(e) {
            if(!e) return;
            this.params.rawName = e.name;
            this.params.rawId = e.id;
        },
        // 选择站点
        changeStation(e) {
            if(!e) return;
            this.params.station = e.name;
            this.params.stationId = e.id;
        },
        // 打开弹框
        async onOpen() {
            const userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
            // // 公司信息
            // this.params.company = userInfo.companyName;
            // this.params.companyId = userInfo.companyId;
            // 站点下拉数据
            getStationByCompanyId({ id: userInfo.companyId }).then((res) => {
                this.siteIdList = res.data.map(res => ({ name: res.stationName, id: res.id }));
                if(this.config.type === 'edit') {
                    if(!this.siteIdList.find(item=>item.id === this.config.data.stationId)) {
                        this.siteIdList.push(this.station)
                        console.log(this.siteIdList);
                    }
                }
            });
            // 供应商下拉数据(包含合同数据、原物料数据)
            queryRawContractList().then(res=>{
                if(res && res.code === 1001) {
                    this.supplierIdList = res.data.map(item=>({
                        id: item.supplierId,
                        name: item.supplierName,
                        products: item.products,
                        contractId: item.contractId,
                        contractNo: item.contractNo
                    }))
                    if(this.config.type === 'edit') {
                        const raw = this.supplierIdList.find(item=>item.id === this.config.data.supplierId)
                        this.rawIdList = raw && raw.products ? raw.products.map(item=>({id: item.productId, name: item.productName})) : [];
                    }
                }
            })
            console.log(this.params.company, this.$options.data().params)
            if(this.config.type === 'add') {
                this.params = this.$options.data().params;
                this.supplier = {} // 供应商
                this.raw = {} // 原物料
                this.station = {} // 站点
                // 公司信息
                this.params.company = userInfo.companyName;
                this.params.companyId = userInfo.companyId;
            } else if (this.config.type === 'edit') {
                const {company, companyId, supplierName, supplierId, contractNo, contractId, rawName, rawId, station, stationId} = this.config.data;
                this.params = {company, companyId, supplierName, supplierId, contractNo, contractId, rawName, rawId, station, stationId};
                this.supplier = {id: supplierId, name: supplierName} // 供应商
                this.raw = {id: rawId, name: rawName} // 原物料
                this.station = {id: stationId, name: station} // 站点
            }
            console.log(this.params.company)
            // alert(123)
        },
        // 关闭弹框
        onClose() {
            this.$emit('update:visible', false)
        },
        // 确定
        onConfirm() {
            const obj = {
                company: '公司名称', // 公司
                companyId: '公司ID',
                supplierName: '供应商名称', // 供应商
                supplierId: '供应商ID',
                contractNo: '合同号', // 合同
                contractId: '合同ID',
                rawName: '原物料名称', // 原物料
                rawId: '原物料ID',
                station: '站点名称', // 站点
                stationId: '站点ID'
            }
            const keys = Object.keys(obj)
            for (let i = 0; i < keys.length; i++) {
                if(!this.params[keys[i]]) return this.$message.info(obj[keys[i]] + '数据缺失')
            }
            console.log(123, this.params)
            saveSubmitInspection(this.params).then(res=>{
                if(res && res.code === 1001) {
                    this.$message.success("添加成功")
                    this.$emit('updated', false)
                    this.$emit('update:visible', false)
                }
            })
        },
    }
}
</script>
<style lang="scss" scoped>
table {
    border-collapse: collapse;
    border: 0 !important;
    width: 100%;
}
td {
    position: relative;
    width: 120px;
    height: 36px;
    text-align: center;
}
table,th,td{
    border: 1px solid black;
}
.require {
    color: #ff0000;
}
</style>


